var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4033 29.8385V4.17725H0.59687V37.5966H28.0485L36.4033 29.8385Z",
    fill: "#1C295A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4033 26.258V0.59668H0.59687V34.016H28.0485L36.4033 26.258Z",
    fill: "#FFF4E3",
    stroke: "#202D66",
    strokeWidth: 1.19355
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5969 16.5967V18.5967H22.5969V20.5967H24.5969V18.5967H26.5969V16.5967H24.5969V14.5967H22.5969V16.5967H10.5969ZM20.5969 12.5967H22.5969V14.5967H20.5969V12.5967ZM20.5969 12.5967H18.5969V10.5967H20.5969V12.5967ZM20.5969 22.5967H22.5969V20.5967H20.5969V22.5967ZM20.5969 22.5967H18.5969V24.5967H20.5969V22.5967Z",
    fill: "#1C295A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.3d07ddbeaf23749a917902f74b676cba.svg";
export { ForwardRef as ReactComponent };